import { Transaction } from '../../entities/Transaction'
import { httpClient } from '../http/httpClient'

export type Statistics = {
  completed: number
  completed_value: number

  pending: number
  pending_value: number

  action_required: number
  action_required_value: number

  refunded: number
  refunded_value: number

  refused: number
  refused_value: number

  total: number
  total_value: number
}
export interface TransactionResponse {
  transactions: Transaction[]
  pagination: {
    skip: number
    limit: number
    sort: string
    order: string
    total: number
  }
  statitics: Statistics
  teamStatistics: Statistics
}

export interface TransactionParams {
  type?: string
  sellerIds?: string
  customerIds?: string
  teamIds?: string
  linkId?: string
  startDate?: string
  endDate?: string
  status?: string
  search?: string
  limit?: number
  skip?: number
  flag?: 'statistics' | 'transactions'
}

export async function transaction(params?: TransactionParams | undefined) {
  const { data } = await httpClient.get<TransactionResponse>('/transaction', {
    params,
  })

  return data
}
